/*
 * Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { hasMinLength } from '@common/tech-shared';

import { AfterViewChecked, ChangeDetectorRef, Component, ElementRef, inject, Input, ViewChild } from '@angular/core';
import { NavHeadlineComponent } from '@ods/system';

@Component({
  selector: 'administration-nav-group',
  imports: [NavHeadlineComponent],
  template: `<ods-nav-headline [label]="label" [hidden]="!showContent" data-test-id="headline" />
    <div #navItemContainer [hidden]="!showContent" data-test-id="content" class="flex flex-col gap-2">
      <ng-content></ng-content>
    </div>`,
})
export class NavGroupComponent implements AfterViewChecked {
  readonly changeDetectorRef: ChangeDetectorRef = inject(ChangeDetectorRef);

  @Input() label: string;

  @ViewChild('navItemContainer', { read: ElementRef }) navItemContainer!: ElementRef;

  public showContent = false;

  ngAfterViewChecked(): void {
    this._handleContentVisibility();
    this.changeDetectorRef.detectChanges();
  }

  _handleContentVisibility(): void {
    this.showContent = this.childElementExists();
  }

  private childElementExists(): boolean {
    return hasMinLength(this.getContainerChildNodes(), 1);
  }

  private getContainerChildNodes(): Node[] {
    return Array.from(this.navItemContainer.nativeElement.children);
  }
}
